export default function About(props){
    return <div>
        <h1>About</h1>
        <p>This is an about page</p>
    </div>
}